import React from 'react';
import { Modal, Button } from 'antd';
import PropertyQrPanel from './PropertySettings/PropertyQrPanel';

/**
 * Quick Property QR modal from /manage-properties dropdown.
 */
const PropertyQrModal = ({ visible, property, onCancel }) => {
  const title = property && property.name
    ? `Property QR Code — ${property.name}`
    : 'Property QR Code';

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="close" onClick={onCancel}>
          Close
        </Button>,
      ]}
      width={560}
      destroyOnClose
    >
      {property && property.id ? (
        <PropertyQrPanel propertyId={property.id} />
      ) : null}
    </Modal>
  );
};

export default PropertyQrModal;
